import NowLabelWithZipInteraction from 'views/components/molecules/NowLabelWithZipInteraction'
import { NOW_SHIPPING_CART_MODAL_ID } from 'views/components/organisms/NowShippingModal/names'
import { OPEN_NOW_CART_SHIPPING_MODAL } from 'views/containers/browser/NowShippingModalCartContainer/clientsideHook'

type Props = {
  upid: string
  nowProduct: boolean
  isInNowProductGroup: boolean
}

const NowProductGroupLabel = (props: Props) => (
  <div
    hidden={!(props.nowProduct || props.isInNowProductGroup)}
    tabIndex={0}
    role={'button'}
    className="u-margin-x-small--bottom u-margin-x-small--top o-ProductInfo__labels"
    data-clientside-hook={OPEN_NOW_CART_SHIPPING_MODAL}
    data-a11y-dialog-show={NOW_SHIPPING_CART_MODAL_ID}
  >
    <NowLabelWithZipInteraction
      displayNowWidget={props.isInNowProductGroup}
      nowEligible={props.nowProduct}
    />
  </div>
)

export default NowProductGroupLabel
